import { TOKEN_DECIMALS } from '../quotes/curveMath';
import { formatTokenBalance } from './tokenBalanceFormat';

function formatSolFromLamports(lamports) {
  const normalizedValue = String(lamports ?? '').trim();

  if (!/^\d+$/.test(normalizedValue)) {
    return '';
  }

  const wholePart = normalizedValue.length > 9 ? normalizedValue.slice(0, -9) : '0';
  const fractionalPart = normalizedValue.slice(-9).padStart(9, '0');
  const trimmedFractionalPart = fractionalPart.replace(/0+$/, '');
  const formattedWholePart = Number(wholePart).toLocaleString();

  if (!trimmedFractionalPart) {
    return `${formattedWholePart} SOL`;
  }

  return `${formattedWholePart}.${trimmedFractionalPart} SOL`;
}

export function formatBuyQuoteValue(tokenAmountOutAtomic) {
  return formatTokenBalance(tokenAmountOutAtomic, TOKEN_DECIMALS);
}

export function formatSellQuoteValue(netLamportsOut) {
  return formatSolFromLamports(netLamportsOut);
}